import React from "react";
import { Row, Col, Button, MessageBanner } from "@folio/stripes/components";
import { useFieldArray, useFormContext } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import { firstOnix } from "../../utils/selectMappers";
import { useOnixOptions } from "../../hooks/title/useOnixOptions";
import { pickFirstCzechLanguage } from "../../utils/pickFirstCzechLanguage";
import { useItemEditor } from "../../hooks/title/useItemEditor";
import { useContentRows } from "../../utils/toContentRows";
import { FormSectionModal } from "./FormSectionModal";
import { useFieldArrayErrors } from "../../hooks/useFieldArrayErrors";
import { EntityRowList } from "./EntityRowList";
import css from "./FormModal.module.css";
var TitleLanguagesForm = function () {
    var _a, _b;
    var formatMessage = useIntl().formatMessage;
    var _c = useFormContext(), control = _c.control, getValues = _c.getValues;
    var errorMessages = useFieldArrayErrors("languages");
    var _d = useFieldArray({ control: control, name: "languages" }), languageFields = _d.fields, appendLanguage = _d.append, updateLanguage = _d.update, removeLanguage = _d.remove;
    var _e = useOnixOptions(), languageRoleTable = _e.languageRoleTable, languageRoleLoading = _e.languageRoleLoading, languageRoleStatus = _e.languageRoleStatus, languageTable = _e.languageTable, languageLoading = _e.languageLoading, languageStatus = _e.languageStatus;
    var _f = useItemEditor({
        appendItem: appendLanguage,
        updateItem: updateLanguage,
        createEmpty: function () { return ({
            role: firstOnix(languageRoleTable),
            language: pickFirstCzechLanguage(languageTable === null || languageTable === void 0 ? void 0 : languageTable.onixCodetableItems),
        }); },
    }), isOpen = _f.isOpen, isEditing = _f.isEditing, draft = _f.draft, setDraft = _f.setDraft, openEditor = _f.openEditor, closeEditor = _f.closeEditor, saveItem = _f.saveItem;
    var contentData = useContentRows(languageFields);
    var columns = [
        {
            name: formatMessage({ id: "ui-br-agency.title.languages.role.label" }),
            cellRenderer: function (row) { var _a; return ((_a = row.role) === null || _a === void 0 ? void 0 : _a.description) || "-"; },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.title.languages.language.label",
            }),
            cellRenderer: function (row) { var _a; return ((_a = row.language) === null || _a === void 0 ? void 0 : _a.description) || "-"; },
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 }, languageFields.length > 0 ? (React.createElement(EntityRowList, { data: contentData, columns: columns, onEdit: function (row) {
                    return openEditor(getValues("languages.".concat(row._index)), row._index);
                }, onDelete: function (row) { return removeLanguage(row._index); }, canDelete: function () { return languageFields.length > 1; } })) : (React.createElement("div", { className: css.emptyState },
                React.createElement(FormattedMessage, { id: "ui-br-agency.title.languages.empty" }))))),
        errorMessages.length > 0 && (React.createElement(Row, { "data-error-field": "languages" },
            React.createElement(Col, { xs: 12 },
                React.createElement(MessageBanner, { type: "error", className: css.tableErrorBanner }, errorMessages.map(function (msg) { return (React.createElement("div", { key: msg }, msg)); }))))),
        React.createElement(FormSectionModal, { open: isOpen, isEditing: isEditing, draft: draft, onDraftChange: setDraft, onSave: saveItem, onClose: closeEditor, addLabelId: "ui-br-agency.title.languages.form.add.title", editLabelId: "ui-br-agency.title.languages.form.edit.title", fields: [
                {
                    key: "role",
                    labelId: "ui-br-agency.title.language.role.label",
                    type: "onix",
                    required: true,
                    dataOptions: (_a = languageRoleTable === null || languageRoleTable === void 0 ? void 0 : languageRoleTable.onixCodetableItems) !== null && _a !== void 0 ? _a : [],
                    loading: languageRoleLoading,
                    codetableStatus: languageRoleStatus,
                },
                {
                    key: "language",
                    labelId: "ui-br-agency.title.language.language.label",
                    type: "onix",
                    required: true,
                    dataOptions: (_b = languageTable === null || languageTable === void 0 ? void 0 : languageTable.onixCodetableItems) !== null && _b !== void 0 ? _b : [],
                    loading: languageLoading,
                    codetableStatus: languageStatus,
                },
            ], validate: function (d) { var _a, _b; return !!((_a = d.role) === null || _a === void 0 ? void 0 : _a.value) && !!((_b = d.language) === null || _b === void 0 ? void 0 : _b.value); } }),
        React.createElement(Row, { className: css.actions },
            React.createElement(Col, { xs: 12 },
                React.createElement(Button, { buttonStyle: "primary", onClick: function () { return openEditor(); } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.title.form.add.language" }))))));
};
export default TitleLanguagesForm;
